<template>
  <q-btn
    icon="fa fa-bell"
    color="grey-8"
    round
    dense
    flat
  >
    <q-badge
      v-if="numUnread"
      color="red"
      text-color="white"
      :label="numUnread"
      floating />
    <q-menu>
      <user-notifications-list
        :user-id="userId"
        :user-notifications="userNotifications"
        :total="numUnread"
        @marked-one-read="markRead"
        @marked-read="markAllRead" />
    </q-menu>
    <q-tooltip>{{ tooltip }}</q-tooltip>
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserContextMixin } from '@/mixins';
import { QueryResult, UserNotification } from '@/type';
import UserNotificationsList from '@/user-notification/UserNotificationsList.vue';
import repository from './user-notification-repository';

  interface Data {
    timerId: ReturnType<typeof setInterval>|null,
    task: Promise<QueryResult>|null,
    loading: Boolean,
    numUnread: number,
    userNotifications: UserNotification[],
    total: number,
  }

export default defineComponent({
  mixins: [UserContextMixin],
  data(): Data {
    return {
      timerId: null,
      task: null,
      loading: false,
      numUnread: 0,
      userNotifications: [],
      total: 0,
    };
  },
  computed: {
    tooltip(): string {
      return `${this.numUnread ? this.numUnread : 'No'} unread notification${(this.numUnread === 1) ? '' : 's'}`;
    },
  },
  methods: {
    markRead(userNotification: UserNotification): void {
      const index = this.userNotifications.findIndex(un => un.id === userNotification.id);
      if (index >= 0) {
        this.numUnread -= 1;
        this.userNotifications.splice(index, 1);
      }
    },
    markAllRead(): void {
      this.numUnread = 0;
      this.userNotifications = [];
    },
    pull(): void {
      this.task = repository.findAllUnread(this.userId);
      this.task.then((result: QueryResult) => {
        this.numUnread = result.total;
        this.userNotifications = (result.items as UserNotification[]);
      });
    },
  },
  created(): void {
    this.pull();
    this.timerId = setInterval(this.pull, 30000);
  },
  beforeUnmount(): void {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  components: {
    'user-notifications-list': UserNotificationsList,
  },
});
</script>
